import { useEffect, useState } from "react"

export type ColumnVisibility = Record<string, boolean>;

/**
 * Persists table column visibility in localStorage per storage key.
 * A column not present in the stored state defaults to visible.
 */
function useColumnVisibility(
    storageKey: string
): [ColumnVisibility, React.Dispatch<React.SetStateAction<ColumnVisibility>>] {
    const [visibility, setVisibility] = useState<ColumnVisibility>(() => {
        try {
            const raw = localStorage.getItem(storageKey);
            return raw ? (JSON.parse(raw) as ColumnVisibility) : {};
        } catch {
            return {};
        }
    });

    useEffect(() => {
        localStorage.setItem(storageKey, JSON.stringify(visibility));
    }, [visibility, storageKey]);

    return [visibility, setVisibility];
}

export default useColumnVisibility;
